// src/components/appt-notes-handler.js

import React, {useEffect, useState} from 'react';
import { RestHelper } from '../helper/restHelper'


const ApptNotesHandler = (data) => {
    const [message, setMessage] = useState('')
    const [storedMessages, setStoredMessages] = useState([{}])
    const [dataFetched, setDataFetched] = useState(false)
    const [showNotaryMessage, setShowNotaryMessage] = useState(false)
    const api = RestHelper()


    useEffect(() => {
        if (data.role == 'notary'){
          setShowNotaryMessage(true)
        }
      }, []);

    function getNotes() {
      setMessage('')
      const reqData = { 'action' : 'read', 'unique_id' : data.requestId}
      const options = {}
      api
        .postCreate('/note-manage-all', options, reqData)
        .then(res => processResponse(res))
        .catch(err => console.log(err))
     }

     function processResponse(res) {
      setStoredMessages(res)
      setDataFetched(true)
      var submitVar = document.getElementById('addNotesButton')
      submitVar.removeAttribute("disabled")
     }

     function addNotes() {
      var submitVar = document.getElementById('addNotesButton')
      submitVar.setAttribute("disabled", "disabled")
      const reqData = { 'action' : 'create', 'unique_id' : data.requestId, 'message' : message}
      const options = {}
      api
        .postCreate('/note-manage-all', options, reqData)
        .then(res => getNotes())
        .catch(err => console.log(err))
     }

    const convertToSimpleDate = (updatedTime) => {
        const date = new Date(updatedTime*1000)
        const dateString = date.toLocaleString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        })
        return dateString
      }

      useEffect (() => {
        getNotes();
      }, []);

    const onChangeEvent = (evt) => {
        const value = evt.target.value;
        setMessage(value)
    }

    function handleProductNavigation(event) {
      const btnRef = document.getElementById("refresh")
      btnRef.blur()
      getNotes()
    }

    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        // event.preventDefault();
        // If editFlag is true, the preview button was selected and the updated form values are ready for review
        addNotes()
        console.log(storedMessages)
    }


  return (
    <div className="bg-white rounded-xl shadow-md border border-neutral-200 mb-4 overflow-hidden">
      <div className="px-3 sm:px-5 py-3 border-b border-neutral-200 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-neutral-800">Message Center</h2>
          <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
        </div>
        <button
          className="text-neutral-500 hover:text-neutral-700 p-2 rounded-lg hover:bg-neutral-100 transition-colors"
          title="Refresh messages"
          id="refresh"
          onClick={() => handleProductNavigation()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      </div>

      <div className="p-3 sm:p-5">
        {dataFetched && storedMessages.length > 0 && (
          <div className="space-y-4 mb-6">
            {storedMessages.map((items, index) => (
              <div key={index} className="bg-neutral-50 rounded-lg border border-neutral-200 p-3">
                <div className="mb-2">
                  <p className="font-medium text-neutral-800">
                    {items.creator} <span className="text-neutral-500 font-normal text-sm">{convertToSimpleDate(items.timeStamp)}</span>
                  </p>
                </div>
                <p className="text-neutral-700 mb-3">{items.message}</p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs text-neutral-500">
                  <div>
                    {items.escrowRead
                      ? <span className="text-green-600">Reviewed by {items.escrowName}</span>
                      : <span>Unread by Escrow Officer</span>}
                  </div>
                  <div>
                    {items.notaryRead
                      ? <span className="text-green-600">Reviewed by {items.notaryName}</span>
                      : <span>Unread by Signing Agent</span>}
                  </div>
                  <div>
                    {items.adminRead
                      ? <span className="text-green-600">Reviewed by PFS</span>
                      : <span>Unread by PFS</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {showNotaryMessage && (
          <div className="bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 rounded-lg mb-4 text-sm">
            <strong>IMPORTANT</strong> - Please do not discuss fees in these messages. Call or email Michael at Pinpoint Field Services directly with these questions.
          </div>
        )}

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-neutral-700 mb-2">Add new message</label>
          <textarea
            className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            id="message"
            onChange={(e) => onChangeEvent(e)}
            value={message}
            rows="3"
            placeholder="Type your message here..."
          />
          <div className="flex justify-end mt-3">
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
              id="addNotesButton"
              onClick={() => onSubmitHandler()}
            >
              Add Message
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApptNotesHandler;